import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faCheckCircle, faTimesCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TripContext } from 'contexts';
import React, { FC, useContext } from 'react';
import { useOrderItemService } from 'services';
import { OrderItemChange } from 'services/types';
import './reconcile-reason-grid.scss';

type Props = {
  changeId: number | undefined,
  reconcileDescription: string,
  quantity: number
};

export const ReconcileReasonRow: FC<Props> = ({ changeId, reconcileDescription, quantity }) => {
  const tripContext = useContext(TripContext)
  const { isOrderItemChangeComplete } = useOrderItemService()
  const change: OrderItemChange = tripContext.orderItemChanges.find(c => c.id == changeId) ?? {} as OrderItemChange

  const reconicleComplete = (item: OrderItemChange): React.ReactNode => {
    return isOrderItemChangeComplete(item) ? <FontAwesomeIcon icon={faCheckCircle as IconProp} size={'1x'} color={'#76AB21'} /> : <FontAwesomeIcon icon={faTimesCircle as IconProp} size={'1x'} color={'#EB5757'} />
  };

  return (
    <div className={'reconcile-reason-grid-row'}>
      <div className={'reconcile-reason-grid-text'} style={{ width: '60%' }}>{reconcileDescription}</div>
      <div className={'reconcile-reason-grid-text'} style={{ width: '20%' }}>{quantity}</div>
      <div className={'reconcile-reason-grid-text'} style={{ width: '20%' }}>
        {reconicleComplete(change)}
      </div>
    </div>
  )
}
